import React from 'react';

class InfluenceFreeText extends React.Component {
    render() {
        const {
            freeTextMessage, handleChange, questionNumber, addFreeTextMessageLabel
        } = this.props;
        return (
            <div className="toch-survey__textblock">
                {
                    addFreeTextMessageLabel &&
                    <div className="toch-survey__label" >{freeTextMessage}</div>
                }
                <textarea className="toch-survey__textarea" name={questionNumber} onChange={(e) => handleChange(questionNumber, null, e)}></textarea>
            </div>
        );
    }
}

export default InfluenceFreeText;
